var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurityIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2206",
    "data-name": "Group 2206",
    transform: "translate(-926 -357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_155",
    "data-name": "Ellipse 155",
    transform: "translate(926 357)",
    fill: "#fff",
    stroke: "#de0000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_156",
    "data-name": "Ellipse 156",
    cx: 31,
    cy: 31,
    r: 31,
    transform: "translate(945 376)",
    fill: "rgba(222,0,0,0.33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "noun-lock-5396952",
    d: "M153.97,27.1h15.206V22.839a7.6,7.6,0,0,0-15.206,0Zm8.227,8.58a2.028,2.028,0,1,0-1.249,0V38.4a.624.624,0,1,0,1.249,0Zm8.227-8.569a2.509,2.509,0,0,1,2.268,2.486v11.54a2.489,2.489,0,0,1-.733,1.763l-.038.035a2.488,2.488,0,0,1-1.726.7H152.95a2.507,2.507,0,0,1-2.5-2.5V29.6a2.509,2.509,0,0,1,2.267-2.486V22.839a8.852,8.852,0,0,1,17.7,0v4.273Z",
    transform: "translate(814.427 378.19)",
    fill: "#de0000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityIcon);
export default __webpack_public_path__ + "static/media/security-icon.010ac9358e9dcd893cc67ae948e74808.svg";
export { ForwardRef as ReactComponent };